import type { components } from "@/api-schema";
import { AppRoleIdentifierSystem } from "@/api-schema-enums";

type AppRole = Pick<components["schemas"]["AppRole"], "appRoleIdentifiers">;

export function getAppRoleV1Identifier(appRole: AppRole): string | undefined {
  return appRole.appRoleIdentifiers?.find((identifier) => identifier.type === AppRoleIdentifierSystem.V1)?.identifier;
}
